module.exports = __webpack_public_path__ + "static/gallery_west_street_5-a3ff7447e6de9ec90d0ff3c2cc73645b.jpg";